import { useEffect, useMemo } from 'react';
import { IntlProvider } from 'react-intl';
import { I18nProvider } from 'react-aria';
import numbro from 'numbro';
import MainRouter from './MainRouter';
import GlobalContext, { type GlobalContextValue } from './common/GlobalContext';
import messages from './utils/intl/messages';
import { NUMBRO_LOCALES } from './utils/intl/numbroLocales';
import { DEFAULT_LOCALE } from './utils/intl/locale';

function App() {
  const locale = DEFAULT_LOCALE;

  useEffect(() => {
    document.documentElement.setAttribute('lang', locale);
    numbro.setLanguage(NUMBRO_LOCALES[locale]);
  }, [locale]);

  const localeValue = useMemo<GlobalContextValue>(() => ({ locale }), [locale]);

  return (
    <IntlProvider locale={locale} messages={messages[locale]}>
      {/* I18nProvider is needed for properly localized screen reader
        messages in components built with react-aria */}
      <I18nProvider locale="de-AT">
        <GlobalContext.Provider value={localeValue}>
          <div className="App">
            <MainRouter />
          </div>
        </GlobalContext.Provider>
      </I18nProvider>
    </IntlProvider>
  );
}

export default App;
